import { IKpiResults, parseDate } from '@report-content';
import { Highcharts } from 'components/chart/Chart';
import { SeriesMovingAverageId } from './index';
import { TFunction } from 'i18next';
import { IKpiChartVarianceSettings } from '@report-content';
import { Theme } from '@mui/material';

export function getMovingAverage(
    varianceSettings: IKpiChartVarianceSettings,
    kpiResults: IKpiResults[],
    xColumn: string,
    t: TFunction,
    theme: Theme,
): Highcharts.SeriesLineOptions {
    const data = kpiResults
        .map((row) => {
            const xVal = String(row[xColumn]);
            if (null == xVal) {
                return null;
            }
            const x = parseDate(xVal).getTime();
            return {
                x: x,
                y: row.moving_avg,
            };
        })
        .filter((p) => p != null);

    return {
        //@ts-ignore
        type: 'line',
        name: t('kpi_chart.chart_label_last_moving_average', { amount: varianceSettings.varianceCompareValuePeriod }),
        id: SeriesMovingAverageId,
        color: theme.componentSettings.highstockChart.movingAverage,
        enableMouseTracking: false,
        data: data,
    };
}
